<template>
  <div class="template-data-step"
       :class="{'main-top-layout': topRoute}"
       v-loading="step.loading"
       element-loading-text="页面加载中，请稍等...">
    <div class="data-step">
      <el-card shadow="never" v-if="step.orders">
        <div slot="header" class="clearfix">
          <span>
            {{step.title}}
          </span>
          <div class="step-menu-group">
            <el-tooltip :content="step.collapsed ? '显示步骤' : '隐藏步骤'" placement="top" :enterable="false">
              <el-button class="step-menu-item" type="text" @click="toggleStepListView">
                <i class="iconfont" :class="step.collapsed ? 'icon-bottom' : 'icon-top'"></i>
              </el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="data-step-content layout-border-flex">
          <el-collapse-transition>
            <div class="data-step-header layout-flex-around" v-show="!step.collapsed">
              <div class="data-step-pane">
                <el-steps :active="step.active" align-center>
                  <el-step v-for="(order, index) in step.orders"
                           :key="'data-step-' + index"
                           :title="order.title"
                           :description="order.description"
                           :icon="order.icon"></el-step>
                </el-steps>
              </div>
              <div class="step-control-group">
                <el-button type="primary" size="mini" plain
                           :disabled="isFirstStep || !share.allowPrev"
                           @click="handlePrevStep">上一步</el-button>
                <el-button type="primary" size="mini" plain
                           :disabled="isLastStep || !share.allowNext"
                           @click="handleNextStep">下一步</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="data-step-router layout-flex-center">
            <RouteKeepAlive :route-matches="stepOrderIds"
                            :share-params="share.params"
                            @setAllowPrev="setAllowPrev"
                            @setAllowNext="setAllowNext"
                            @resetSteps="resetSteps"></RouteKeepAlive>
          </div>
        </div>
      </el-card>
      <template v-else>
        <Hint class="step-load-failed" :icon="false" v-if="!step.loading">
          <span>页面加载失败</span>
          <div class="button-group">
            <el-button type="primary" size="mini" plain @click="loadStepData">点击重试</el-button>
          </div>
        </Hint>
      </template>
    </div>
  </div>
</template>

<script>
import RouteKeepAlive from '../elements/route/RouteKeepAlive'
import baseApiUrl from '../../constants/baseApiUrl'
import routeConfig from '../../constants/routeConfig'
import routeUtils from '../../util/routeUtils'
import Support from '../../mixins/support'
import Hint from '../elements/Hint'
export default {
  mixins: [Support],
  name: 'TemplateDataStep',
  components: {RouteKeepAlive, Hint},
  data () {
    return {
      step: {
        loading: false,
        loaded: false,
        title: null,
        collapsed: false,
        orders: null,
        active: -1
      },
      share: {
        allowPrev: false,
        allowNext: false,
        params: {}
      }
    }
  },
  computed: {
    isFirstStep: function () {
      return this.step.active === 0
    },
    isLastStep: function () {
      if (this.step.orders) {
        return this.step.active === this.step.orders.length - 1
      } else {
        return true
      }
    },
    stepOrderIds: function () {
      let orders = this.step.orders
      if (orders) {
        return orders.map(order => order.name)
      } else {
        return null
      }
    }
  },
  methods: {
    toggleStepListView () {
      this.step.collapsed = !this.step.collapsed
    },
    handlePrevStep () {
      if (this.step.active > 0) {
        this.step.active--
      }
    },
    handleNextStep () {
      if (this.step.active < this.step.orders.length - 1) {
        this.step.active++
      }
    },
    openActiveStep () {
      let orders = this.step.orders
      if (orders) {
        let order = orders[this.step.active]
        if (order) {
          let currentPath = routeUtils.getCurrentRoutePath(this, this.$route)
          this.$router.replace({ path: currentPath + order.path })
        }
      }
    },
    loadStepData () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataStep.param]) {
        return
      }
      this.step.loading = true
      this.$ajax({
        url: baseApiUrl.DataStepUrl,
        method: 'post',
        data: this.$qs.stringify(postParams, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          this.step.title = response.data['title']
          this.step.collapsed = response.data['collapsed']
          this.step.orders = response.data['orders']
          // 跳转到第一步
          this.step.active = 0
        }
      }).finally(() => {
        this.step.loading = false
        this.step.loaded = true
      })
    },
    setAllowPrev (enable) {
      this.share.allowPrev = enable
    },
    setAllowNext (enable) {
      this.share.allowNext = enable
    },
    resetSteps () {
      this.share.allowPrev = false
      this.share.allowNext = false
      this.share.params = {}
      this.step.active = 0
    }
  },
  beforeRouteUpdate (to, from, next) {
    let matchId = routeUtils.getRouteMatchId(this, to)[0]
    if (matchId) {
      next()
    } else {
      if (routeUtils.getCurrentRoutePath(this, to) === routeUtils.getCurrentRoutePath(this, from)) {
        this.step.active = 0
        next(false)
      } else {
        next()
      }
    }
  },
  watch: {
    'step.active': function () {
      this.openActiveStep()
    }
  },
  mounted () {
    this.loadStepData()
  },
  activated () {
    if (this.step.loaded) {
      if (this.step.orders) {
        this.openActiveStep()
      } else {
        this.loadStepData()
      }
    }
  }
}
</script>

<style lang="scss">
  .template-data-step {
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    &.main-top-layout {
      padding: 10px;
    }
    & > .data-step {
      position: relative;
      height: 100%;
      & > .el-card {
        position: relative;
        height: 100%;
        border-radius: 0;
        border: none;
        background-color: transparent;
        & > .el-card__header {
          position: relative;
          height: 32px;
          padding: 0 0 0 15px;
          font-size: 12px;
          line-height: 32px;
          background-color: #fff;
          border-bottom: none;
          .step-menu-group {
            float: right;
            .step-menu-item {
              float: left;
              position: relative;
              display: inline-block;
              min-width: 32px;
              height: 32px;
              text-align: center;
              padding: 0 6px;
              & + .step-menu-item {
                margin-left: 0;
              }
              i {
                color: #303133;
                font-size: 12px;
              }
            }
          }
        }
        & > .el-card__body {
          position: absolute;
          left: 0;
          top: 32px;
          width: 100%;
          bottom: 0;
          padding: 0;
          .data-step-content {
            height: 100%;
            & > .data-step-header {
              & > .data-step-pane {
                position: relative;
                padding: 15px 0;
                background-color: #fff;
                border-top: 1px solid #ebeef5;
                & > .el-steps {
                  & > .el-step {
                    & > .el-step__head {
                      .el-step__icon {
                        border-width: 1px;
                      }
                    }
                    & > .el-step__main {
                      & > .el-step__title {
                        font-size: 12px;
                        line-height: 30px;
                      }
                    }
                  }
                }
              }
              & > .step-control-group {
                position: relative;
                padding: 10px 15px;
                text-align: center;
                background-color: #fff;
                .el-button {
                  padding: 5px 15px;
                  & + .el-button {
                    margin-left: 4px;
                  }
                }
              }
            }
            & > .data-step-router {
              position: relative;
              height: 100%;
              padding-top: 10px;
              overflow: hidden;
            }
          }
        }
      }
      .step-load-failed {
        .button-group {
          margin: 10px auto;
          text-align: center;
          .el-button {
            padding: 5px 12px;
            border-radius: 0;
          }
        }
      }
    }
  }
</style>
